import CryptoJS from 'crypto-js'

import { CRYPTO_SECRET } from 'constants/crypto'

export function decrypt(value: string) {
  const decryptValue = CryptoJS.AES.decrypt(value, CRYPTO_SECRET)
  console.log(decryptValue)
  const decryptedParse = JSON.parse(decryptValue.toString(CryptoJS.enc.Utf8))
  console.log(decryptedParse)
  return decryptedParse
}
